import ApiServices from "@/services/uteis/ApiServices.js";
import route from "@/libs/endPoint/rh/InscricaoDistribuicaoRoutes";
import store from "@/store/index.js";
class InscricaoRemocaoServices {
  async dadosInscricaoUsuario(params) {
    try {
      const url = route.dadosInscricao;
    
      const { data } = await ApiServices.get(url, params);
      if (data.length == 0) {
        return { success: false, message: "Nenhuma inscrição encontrada para o usuário." };
      }
      const inscricao = { cabecalho: {}, datas: [] }; // Supondo que você queira o primeiro registro
      const keyCabecalo = "pkinscricao,pkpessoa,nome,cpf,data_inscricao";
      const tm={ano:0,mes:0,dia:0};
      const keyDatas =
        "pkdatadistribuicao,descricao,data_distribuicao,data_encerramento,h_inicio,local,uppload_doc,id_item";
      let docs = false;
      data.map((i) => {
        tm.ano=i.anos_magisterio;
        tm.mes=i.meses_magisterio;
        tm.dia=i.dias_magisterio;
         inscricao.cabecalho.tempo_magisterio=tm;
        if (!inscricao.cabecalho.pkinscricao) {
          keyCabecalo.split(",").map((k) => {
            inscricao.cabecalho[k] = i[k];
          });
        }
        const item = {};

        keyDatas.split(",").map((k) => {
          item[k] = i[k];

          if (k == "uppload_doc") {
            if (String(i[k]).trim().length > 0) docs = true; // Se docs for false, seta como string vazia
          }
        });
        inscricao.cabecalho.docs = docs;
        inscricao.cabecalho.tempo_magisterio=tm;
        if(item.pkdatadistribuicao>0){
        inscricao.datas.push(item);
        }
      });

      store.commit("remocao/setInscricaoUsuario", inscricao);

      return data;
    } catch (error) {
      console.error("Erro ao buscar dados da inscrição:", error);
      throw error;
    }
  }
}
export default new InscricaoRemocaoServices();
